export { default } from "./ChallengesTeacherTabsContainer";
